export default __webpack_public_path__ + "static/media/MCP Veransa Announcement 2021 12 16.459dde4a.pdf";